import React from "react";
import { Helmet } from "react-helmet-async";

const Durgapur = () => {
  return (
    <>
      <Helmet>
        <title>Fly Ash Bricks, Blocks & Paver Blocks in Durgapur | Anil Flyash Bricks</title>
        <meta
          name="description"
          content="Buy high-quality fly ash bricks, blocks, and paver blocks in Durgapur from Anil Flyash Bricks — trusted manufacturer and dealer of durable, eco-friendly construction materials across West Bengal."
        />
        <meta
          name="keywords"
          content="bricks in Durgapur, flyash bricks in Durgapur, fly ash blocks in Durgapur, bricks dealers in Durgapur, flyash bricks manufacturer Durgapur, paver block Durgapur, construction materials in Durgapur, Anil Flyash Bricks Durgapur"
        />
        <link rel="canonical" href="https://anilbricks.com/flyash-bricks-in-durgapur" />
      </Helmet>

      <div className="py-16 px-6 md:px-20 bg-gray-50 text-gray-800">
        <h1 className="text-3xl font-bold mb-6 text-green-700 text-center">
          Fly Ash Bricks, Blocks & Paver Blocks in Durgapur
        </h1>

        <p className="text-lg leading-relaxed mb-4">
          Welcome to <strong>Anil Flyash Bricks</strong> — your reliable source for
          <strong> fly ash bricks, blocks, and paver blocks</strong> in <strong>Durgapur</strong>.
          We are a leading manufacturer and supplier committed to delivering high-strength,
          eco-friendly, and affordable construction materials across West Bengal.
        </p>

        <p className="text-lg leading-relaxed mb-4">
          Our <strong>fly ash bricks</strong> are made using modern techniques that ensure
          superior compressive strength, dimensional accuracy, and long-lasting durability.
          They are the ideal choice for residential, commercial, and industrial construction
          projects in Durgapur and neighboring areas.
        </p>

        <p className="text-lg leading-relaxed mb-4">
          In addition, our <strong>paver blocks</strong> and <strong>fly ash blocks</strong>
          are highly durable and visually appealing — perfect for driveways, parking spaces,
          and pathways. We offer a wide range of shapes, colors, and finishes to meet your
          architectural requirements.
        </p>

        <p className="text-lg leading-relaxed mb-4">
          Whether you are searching for <em>“bricks dealers in Durgapur”</em>,
          <em>“paver block manufacturer near me”</em>, or
          <em>“fly ash block supplier in West Bengal”</em>,
          <strong>Anil Flyash Bricks</strong> is the name you can trust.
          We deliver across <strong>Durgapur, City Center, Benachity, Andal, and Raniganj</strong>,
          ensuring timely supply and consistent quality.
        </p>

        <p className="text-lg leading-relaxed mb-6">
          For wholesale supply, dealership, or franchise opportunities in Durgapur,
          contact us today and experience top-quality products with professional service.
        </p>

        <a
          href="/"
          className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-full font-semibold shadow-md transition"
        >
          Visit Main Website
        </a>
      </div>
    </>
  );
};

export default Durgapur;
